"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = require("react");
var ReactDOM = require("react-dom");
var modalClassName = "starryui-modal";
var srwClassName = "srw";
var focusFirstFocusableElement = function (element) {
    var firstFocus = element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    var focusableEls = Array.prototype.slice.call(firstFocus);
    var firstFocusableEl = focusableEls[0];
    if (firstFocusableEl) {
        firstFocusableEl.focus();
    }
};
var Modal = function (_a) {
    var DisableAutoFocus = _a.DisableAutoFocus, children = _a.children;
    var element = react_1.useState(document.createElement("div"))[0];
    element.className = srwClassName + " " + modalClassName;
    react_1.useEffect(function () {
        var modalRoot = document.body;
        modalRoot.appendChild(element);
        if (!DisableAutoFocus) {
            focusFirstFocusableElement(element);
        }
        return function () {
            modalRoot.removeChild(element);
        };
    }, [element]);
    return ReactDOM.createPortal(children, element);
};
exports.Modal = Modal;
